import * as React from 'react';

export const BookIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13 1.25H4.5C3.90326 1.25 3.33097 1.48705 2.90901 1.90901C2.48705 2.33097 2.25 2.90326 2.25 3.5V14C2.25 14.1989 2.32902 14.3897 2.46967 14.5303C2.61032 14.671 2.80109 14.75 3 14.75H12C12.1989 14.75 12.3897 14.671 12.5303 14.5303C12.671 14.3897 12.75 14.1989 12.75 14C12.75 13.8011 12.671 13.6103 12.5303 13.4697C12.3897 13.329 12.1989 13.25 12 13.25H3.75V13C3.75 12.8011 3.82902 12.6103 3.96967 12.4697C4.11032 12.329 4.30109 12.25 4.5 12.25H13C13.1989 12.25 13.3897 12.171 13.5303 12.0303C13.671 11.8897 13.75 11.6989 13.75 11.5V2C13.75 1.80109 13.671 1.61032 13.5303 1.46967C13.3897 1.32902 13.1989 1.25 13 1.25ZM12.25 10.75H4.5C4.24446 10.7495 3.99075 10.7931 3.75 10.8787V3.5C3.75 3.30109 3.82902 3.11032 3.96967 2.96967C4.11032 2.82902 4.30109 2.75 4.5 2.75H12.25V10.75Z"
      fill="currentColor"
    />
  </svg>
);
